<template>
  <footer>
    <div class="px-4 py-6 bg-primary lg:px-10 xl:px-20 xl:py-8">
      <div class="container">
        <nav class="w-full -mb-4 md:mb-0">
          <ul class="flex flex-wrap md:flex-nowrap md:flex-row text-md xl:text-lg">
            <li class="w-1/2 pb-4 pr-2 leading-tight text-gray-200 transition-colors duration-300 ease-in-out md:w-auto md:pb-0 md:pr-6 xl:pr-12 hover:text-white">
              <router-link :to="$i18nTo({ name: 'imprint' })" class="footer-link">
                {{ tr('components.footer.links.imprint') }}
              </router-link>
            </li>
            <li class="w-1/2 pb-4 pr-2 leading-tight text-gray-200 transition-colors duration-300 ease-in-out md:w-auto md:pb-0 md:pr-6 xl:pr-12 hover:text-white">
              <router-link :to="$i18nTo({ name: 'termsOfUse' })" class="footer-link">
                {{ tr('components.footer.links.termsAndConditions') }}
              </router-link>
            </li>
            <li class="w-1/2 pb-4 pr-2 leading-tight text-gray-200 transition-colors duration-300 ease-in-out md:w-auto md:pb-0 md:pr-6 xl:pr-12 hover:text-white">
              <a :href="privacyLink" target="_blank" class="footer-link">
                {{ tr('components.footer.links.privacy') }}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="px-4 py-6 lg:px-10 xl:px-20 xl:py-6">
      <div class="container">
        <div class="flex flex-col items-center justify-between w-full md:flex-row">
          <div class="pb-4 md:pb-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="116.842" height="20" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="Group 3"><path data-name="LH Logo" d="M10 20A10 10 0 012.93 2.922 10.004 10.004 0 0117.077 17.07 9.934 9.934 0 0110 20zM10 .72A9.28 9.28 0 1019.28 10 9.29 9.29 0 0010 .72zm100.781 16.226a3.465 3.465 0 01-2.517-.883 3 3 0 01-.817-2.183c0-1.892 1.144-2.9 3.6-3.162l1.828-.19c.732-.08.991-.264.991-.705a.692.692 0 00-.379-.621 2.34 2.34 0 00-1.165-.236c-1.291 0-1.492.5-1.523.934H108a2.939 2.939 0 011.14-2.327 5.341 5.341 0 013.183-.8 5.24 5.24 0 013.222.8 3.259 3.259 0 011.122 2.783v6.3h-2.628v-1.2a3.748 3.748 0 01-3.258 1.49zm3.143-4.609a4.82 4.82 0 01-.762.152l-1.657.228c-.847.116-1.276.469-1.276 1.048 0 .639.419.99 1.181.99 1.48 0 2.514-.752 2.514-1.828v-.59zm-11.657 4.609c-2.973 0-4.45-1.059-4.515-3.238h2.838c.078.725.6 1.048 1.676 1.048s1.581-.247 1.581-.8c0-.49-.372-.722-1.371-.857l-1.009-.134c-2.306-.311-3.334-1.239-3.334-3.01a2.834 2.834 0 011.031-2.276 4.9 4.9 0 013.16-.9c2.634 0 4.037 1.051 4.171 3.124h-2.8c-.11-.636-.507-.9-1.371-.9-.848 0-1.315.264-1.315.743 0 .449.284.656 1.047.762l1.01.133c2.632.35 3.657 1.215 3.657 3.086.001 2.105-1.54 3.219-4.456 3.219zm-21.576 0a3.464 3.464 0 01-2.516-.883 3 3 0 01-.817-2.183c0-1.893 1.144-2.9 3.6-3.162l1.828-.19c.731-.08.99-.264.99-.705 0-.545-.562-.857-1.543-.857-1.292 0-1.493.5-1.524.934h-2.8a2.939 2.939 0 011.14-2.327 5.342 5.342 0 013.183-.8 5.239 5.239 0 013.221.8 3.26 3.26 0 011.121 2.783v6.3h-2.626v-1.2a3.747 3.747 0 01-3.257 1.49zm3.143-4.609a4.827 4.827 0 01-.762.152l-1.657.228c-.847.116-1.277.469-1.277 1.048 0 .639.42.99 1.181.99 1.48 0 2.514-.752 2.514-1.828v-.59zm-37.3 4.609c-2.617 0-3.734-1.276-3.734-4.266V7.06h2.876v5.486c0 1.261.545 1.848 1.714 1.848 1.109 0 1.7-.639 1.7-1.848V7.06h2.876v9.6h-2.7v-1.1a2.82 2.82 0 01-2.733 1.386zm18.514-.114a4.036 4.036 0 01-2.712-.814 3.219 3.219 0 01-.983-2.557V9.4H59.9V7.06h1.448v-2.8h2.876v2.8h2.191V9.4h-2.187v3.734c0 .908.41 1.3 1.372 1.3.336 0 .814-.057.819-.057v2.3h-.005a7.128 7.128 0 01-1.367.154zm25.59-.171h-2.877V7.06h2.7v1.105a2.854 2.854 0 012.762-1.391 3.633 3.633 0 012.822.948A4.718 4.718 0 0197 11.041v5.619h-2.877v-5.486a1.958 1.958 0 00-.426-1.4 1.742 1.742 0 00-1.326-.445c-1.15 0-1.733.622-1.733 1.847v5.484zm-20.5 0h-2.875V3.346h2.9v4.647a2.969 2.969 0 012.628-1.219 3.588 3.588 0 012.771.948 4.751 4.751 0 01.943 3.319v5.619h-2.88v-5.486a1.958 1.958 0 00-.426-1.4 1.742 1.742 0 00-1.326-.445c-1.134 0-1.733.639-1.733 1.847v5.484zm-13.092 0h-2.875V9.4h-1.447V7.06h1.448V6.7a3.431 3.431 0 011.021-2.652 3.989 3.989 0 012.75-.909 5.824 5.824 0 011.219.114v2.321s-.4-.038-.743-.038c-.949 0-1.372.353-1.372 1.143v.381h2.115V9.4h-2.115v7.257zm-14.9 0h-8.813V3.327h3.086v10.647h5.733v2.685zM14.5 14.32a20.863 20.863 0 01-4.272-1.29 20.324 20.324 0 01-3.808-2.19 22.688 22.688 0 00-4.64-2.76l-.02-.58 1.4.58.6-.46L7.68 9.4l-.421.32-1.939-.84-.26.24.84.48a5.293 5.293 0 002.16.74h.04c1.411 0 2.679-.984 3.476-2.7a24.2 24.2 0 012.12-.1 24.425 24.425 0 014.64.42l-.48.46a21.788 21.788 0 00-4.056-.36h-.38l-.22.42h.34a23.468 23.468 0 013.92.32l-.46.44a20.6 20.6 0 00-3.64-.26h-.42l-.26.44c.36-.02.637-.02.86-.02a20.066 20.066 0 013.06.22l-.46.44a16.061 16.061 0 00-2.56-.16c-.387 0-.985.019-1.28.04l-.36.44c.513-.041 1-.06 1.52-.06a19.125 19.125 0 012.26.14l-.48.46c-.581-.062-1.172-.1-1.58-.1a6.815 6.815 0 00-3.64.819 7.056 7.056 0 005.12 1.881h.2l-.84.8z" fill="#05164d"/></g></svg>
          </div>
          <div>
            <div>
              <img
                class="alliance_logo white"
                src="../../../images/lufthansa/logos/a_star_alliance.png"
                alt="A Star Alliance member"
                style="width: 205px;"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import Footer from '~brand-components/base/shared/footer'

export default Footer.extend({
  computed: {
    privacyLink() {
      if (this.$i18n.locale === 'de') {
        return 'https://www.lufthansa.com/de/de/datenschutz'
      }

      return 'https://www.lufthansa.com/de/en/data-protection'
    },
  },
})
</script>

<style lang="scss" scoped>
.footer-link {
  position: relative;

  &:focus {
    outline: none;

    &::after {
      content: '';
      position: absolute;
      left: -6px;
      top: -6px;
      width: calc(100% + 12px);
      height: calc(100% + 12px);
      box-shadow: 0 0 6px 1px #fff;

      @apply rounded;
    }
  }
}
</style>
